// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import './assets/icon/iconfont.css'
import axios from './axios'
import 'element-ui/lib/theme-chalk/index.css'
import * as turf from '@turf/turf'
import $ from 'jquery'
import router from './router'
import resource from '@/router/vue-resource.js'
// 在全局入口文件引入，赋值给原型prototype就可以在整个应用中使用了
// Vue.http.headers.post['Content-Type']='application/json'
import less from 'less'
// import '../src/assets/lib-flexible'
Vue.prototype.$source = resource
Vue.use(less)
Vue.use(ElementUI)
Vue.config.productionTip = false
// Vue.http.options.emulateJSON = true;
Vue.http.options.headers = {'Content-type': 'application/json'}
Vue.prototype.http = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js